module.exports = __webpack_public_path__ + "static/media/icon.19e1efa4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/UpApp/images/icon.svg
// module id = 424
// module chunks = 5